// src/AdminPanel.js
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Sidebar from './Sidebar';
import AdminHome from './pages/Home';
import AdminSettings from './pages/Settings';
import AdminUserProfile from './pages/UserProfile';


const AdminPanel = () => {
  return (
    <div className='ha_adminMain_div'>
      <Sidebar />
      <Routes>
        <Route path="/" element={<AdminHome />} />
        <Route path="/Adminsettings" element={<AdminSettings />} />
        <Route path="/Adminuser" element={<AdminUserProfile />} />
        {/* Add more routes for other pages */}
      </Routes>
    </div>
  );
};

export default AdminPanel;
